import { FormSection } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSection';
import { SelectResourceTypes } from '@organisms/IntegrationConnectorForm/SelectResourceTypes';
import { IntegrationConfigAppModelV2 } from '@api';
import { FormSectionSummary } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSectionSummary';
import { SelectConfig } from '@Integrations/organisms/ConnectIntegration/ConnectIntegrationsGroup/SelectConfig';
import { Control, Controller } from 'react-hook-form';
import { ReactNode } from 'react';
import { IntegrationConfigFormPayload } from '@Integrations/organisms/IntegrationConfigForm/Provider';

export function DiscoveryFormSection({
  config,
  options,
  actions,
  control,
  expanded,
}: {
  config?: IntegrationConfigAppModelV2;
  options?: IntegrationConfigAppModelV2[];
  actions?: ReactNode;
  control: Control<IntegrationConfigFormPayload>;
  expanded: boolean;
}) {
  return (
    <FormSection
      expanded={expanded}
      summary={
        <FormSectionSummary
          title="Discovery"
          tooltip="Apono automatically discovers all the instances in the environment. Then, you can start managing access to resources with Access Flows!"
        />
      }
      actions={expanded && actions}
    >
      {options && options.length > 1 && (
        <Controller
          name="type"
          control={control}
          render={({ field }) => (
            <SelectConfig groupedConfigs={options} selectedConfigType={field.value} onSelect={field.onChange} />
          )}
        />
      )}
      {config && (
        <Controller
          name="connected_resource_types"
          control={control}
          render={({ field }) => (
            <SelectResourceTypes config={config} selected={field.value} onSelect={field.onChange} />
          )}
        />
      )}
    </FormSection>
  );
}
